import { useState } from 'react'
import {
  Paper,
  Switch,
  Typography,
  Box,
  IconButton,
  Button,
  Checkbox,
  useTheme,
} from '@mui/material'
import { MdCalendarToday, MdDelete } from 'react-icons/md'
import ModalAdicionarFaixa from './ModalAdicionarFaixa'

const CartaoDia = ({
  dayName,
  dateStr,
  active,
  ranges,
  onToggle,
  onAddRange,
  onRemoveRange,
}) => {
  const [showModal, setShowModal] = useState(false)
  const theme = useTheme()

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: 3,
        opacity: active ? 1 : 0.35,
        transition: 'opacity 0.3s',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box display="flex" alignItems="center" gap={1}>
          <MdCalendarToday color={theme.palette.primary.main} />
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              {dayName}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {dateStr}
            </Typography>
          </Box>
        </Box>
        <Switch checked={active} onChange={onToggle} size="small" />
      </Box>

      <Box mt={1}>
        <Typography
          variant="caption"
          fontWeight="bold"
          color={active ? 'success.main' : 'text.disabled'}
        >
          {active ? 'Aberto' : 'Fechado'}
        </Typography>
      </Box>

      <Box sx={{ mt: 2, pointerEvents: active ? 'auto' : 'none' }}>
        {ranges.map((range, idx) => {
          const isTrabalho = range.type === 'trabalho'
          return (
            <Box
              key={`${range.start}-${range.end}`}
              display="flex"
              alignItems="center"
              sx={{
                bgcolor: isTrabalho
                  ? theme.palette.primary.light + '80'
                  : theme.palette.warning.light + '80',
                borderRadius: 1,
                px: 1.5,
                py: 0.5,
                mb: 0.5,
              }}
            >
              <Checkbox checked size="small" sx={{ p: 0.5, mr: 0.5 }} />
              <Typography variant="body2" sx={{ flex: 1 }}>
                {range.start} às {range.end}
                {!isTrabalho && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ ml: 1, fontStyle: 'italic' }}
                  >
                    (Intervalo)
                  </Typography>
                )}
              </Typography>
              <IconButton
                size="small"
                onClick={() => onRemoveRange(idx)}
                sx={{ color: 'error.main' }}
              >
                <MdDelete size={16} />
              </IconButton>
            </Box>
          )
        })}

        <Button
          fullWidth
          variant="outlined"
          size="small"
          onClick={() => setShowModal(true)}
          disabled={!active}
          sx={{
            mt: 1,
            borderStyle: 'dashed',
            borderColor: theme.palette.grey[400],
            color: 'text.secondary',
            '&:hover': { borderStyle: 'dashed' },
          }}
        >
          + Adicionar horário
        </Button>
      </Box>

      <ModalAdicionarFaixa
        open={showModal}
        onClose={() => setShowModal(false)}
        onAdd={(start, end, type) => {
          onAddRange(start, end, type)
          setShowModal(false)
        }}
      />
    </Paper>
  )
}

export default CartaoDia
